$(function () {
    /* SLICK SLIDERS */
    if ($('.slider').length > 0) {
        $('.slider').slick({
            adaptiveHeight: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            draggable: true,
            fade: true,
            lazyLoad: 'ondemand',
            pauseOnHover: false,
            speed: 1200
        });
    }
    if ($('.gallery-slider').length > 0) {
        $('.gallery-slider').slick({
            draggable: true,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            speed: 650,
            fade: true
        });
    }

    // ADD TOUCHSTART FUNCTION
    if ('ontouchstart' in document.documentElement) {
        document.addEventListener("touchstart", function () {
        }, true);
    }

    // HEADROOM
    var header = new Headroom(document.querySelector("header"), {
        tolerance: 5,
        offset: 205,
        classes: {
            initial: "animated",
            pinned: "slideDown",
            unpinned: "slideUp"
        }
    });
    header.init();

    // READ MORE BUTTONS
    $('.read-more-button a').click(function () {
        var extraTxt = $(this).parent('p').parent('div').find('#read-more-text');
        extraTxt.show('fast');
        extraTxt.css('height', 'auto');
        extraTxt.css('visibility', 'visible');
        var readMore = $(this).parent('p').parent('div').find('.read-more-button');
        readMore.hide();
    });
    $('.read-less-button a').click(function () {
        var extraTxt = $(this).closest('div');
        extraTxt.hide('fast');

        var readMore = $(this).parent('p').parent('div').parent('div').find('.read-more-button');
        readMore.show();
    });

    // SETUP FEEDBACK ACTIONS
    if ($('#feedback').length > 0) {
        $('#close-feedback').on('click', function () {
            $('#feedback').remove();
        });
    }

    // MOBILE MENU
    var mobilemenu = $('#menu-mobile');
    $('#nav-trigger').click(function () {
        mobilemenu.toggleClass('open');
    });
    $('#menu-action-close').click(function () {
        mobilemenu.removeClass('open');
    });
    mobilemenu.find('ul').parent('li').find('a:first').click(function (e) {
        var ul = $(this).parent('li').find('ul');
        ul.slideToggle();
        e.preventDefault();
    });

    // SETUP NEWS GRID
    if ($('.gridalicious').length > 0 || $('.gridalicious_ref').length > 0 || $('.gridalicious_faq').length > 0) {

        $(".gridalicious").gridalicious({
            animate: true,
            selector: '.col-3',
            width: 390,
            gutter: 0,
            animationOptions: {
                queue: true,
                speed: 200,
                duration: 300,
                effect: 'fadeInOnAppear'
            }
        });

        $(".gridalicious_ref").gridalicious({
            animate: true,
            selector: '.col-6',
            width: 780,
            gutter: 0,
            animationOptions: {
                queue: true,
                speed: 200,
                duration: 300,
                effect: 'fadeInOnAppear'
            }
        });

        $(".gridalicious_faq").gridalicious({
            animate: true,
            selector: '.col-6',
            width: 780,
            gutter: 0,
            animationOptions: {
                queue: true,
                speed: 200,
                duration: 300,
                effect: 'fadeInOnAppear'
            }
        });

        $('.more-news').on('click', function () {
            var item = $(this);

            $.ajax({
                type: 'POST',
                url: '/custom/ajax.php',
                dataType: 'json',
                data: {
                    m: 'more_news',
                    l: $('html').attr('lang'),
                    s: item.data('start') ? item.data('start') : 1,
                    e: item.data('end') ? item.data('end') : 8,
                    t: item.data('folder')
                },
                success: function (response) {
                    if (response !== '') {
                        var result = JSON.parse(response);

                        $(".gridalicious").gridalicious('append', result.html);
                        setup_closeable();

                        if (result.start > 0 || result.end > 0) {
                            if ((result.start == 0 || result.end == 0) && (result.end - 8) == item.data('end')) {
                                $('.more-news').hide();
                                $('.no-more-news').show();
                            } else {
                                item.data('start', result.start);
                                item.data('end', result.end);
                            }
                        }
                        else {
                            alert('hier else else');
                            $('.more-news').hide();
                            $('.no-more-news').show();
                        }
                    }
                    else {
                        alert('Problem, try again later...');
                    }
                },
                error: function (response) {
                    alert('Problem, try again later...');
                }
            });
        });
    }

    // SETUP CLOSEABLE BLOCKS
    setup_closeable();

    // SETUP FORMS
    setup_forms();

    // SETUP EQUAL HEIGHT
    setup_equal_height();
});

// FORMS VALIDATE
function setup_forms() {
	'use strict';

    if($('form').length > 0) {
        jQuery.validator.setDefaults({
            onkeyup: false,
            ignoreTitle: true,
            rules: {
                'fld-password': {minlength: 8},
                'number': {number: true}
            }
        });

        $('.formcontact').validate({
            submitHandler: function (form) {
                form.submit();
            }
        });

        $('.form-subscribe-newsletter').validate({
            submitHandler: function (form) {
                form.submit();
            }
        });

		/**
		 * donations
		 */
		var frm_donate =$('form[name="frm-donate"]');

		frm_donate.validate({
			submitHandler: function(form) {
				form.submit();
			}
		});

		$('form[name="frm-donate"] input[name="account[type_gift]"]').on('change', function()
		{
			var rPro = $("input[name='account[type_gift]']"); //console.log('ok', rPro);

			rPro.closest('label').removeClass('checked');

			if(rPro.filter(':checked')) {
				$(this).closest('label').addClass('checked');
			}

			var $radios = $('input:radio[name="account[payment_method]"]');

			if(rPro.filter(':checked').val() == 1) {
				$('.payment-list').find('.banktransfer').hide();
				$('.payment-list').find('.banktransfer').closest('label').removeClass('checked');

				$radios.filter('[value=visa]').prop('checked', true).closest('label').addClass('checked');
				//$radios.filter('[value=visa]').closest('label').addClass('checked');
			}
			else {
				$('.payment-list').find('.banktransfer').show();
			}
		});
		$('form[name="frm-donate"] input[name="account[payment_method]"]').on('change', function()
		{
			var rPro = $("input[name='account[payment_method]']");

			rPro.closest('label').removeClass('checked');

			if(rPro.filter(':checked')) {
				$(this).closest('label').addClass('checked');
			}
		});
		$('form[name="frm-donate"] input[name="account[type_user]"]').on('change', function()
		{
			var rPro = $("input[name='account[type_user]']"); console.log('ok', rPro);

			if(rPro.filter(':checked').val() == 2) {
				$('form .form-row-vereniging').hide();
				$('form .form-row-company').show();
			}
			else if(rPro.filter(':checked').val() == 3) {
				$('form .form-row-company').hide();
				$('form .form-row-vereniging').show();
			}
			else {
				$('form .form-row-company, form .form-row-vereniging').hide();
				$('form .form-row-company input').val('');
			}
		});
		$('form[name="frm-donate"] input[name="account[type_user]"]').trigger("change");
    }
}

// CLOSEABLE BLOCKS
function setup_closeable(closeItems) {
    if ($('.closeable').length > 0) {
        $('.closeable').each(function () {
            var me = $(this);
            closeItems = closeItems || 'true';

            if (closeItems == 'true') {
                $(me).find('.hide').slideUp(0);
                $(me).addClass('closed');
            }

            $(me).find('h2').unbind('click').bind('click', function (e) {
                e.preventDefault();
                if ($(me).hasClass('closed')) {
                    $(me).removeClass('closed')
                    $(me).find('.hide').slideDown('slow');
                } else {
                    $(me).find('.hide').slideUp('slow', function () {
                        $(me).addClass('closed');
                    });
                }
            });
        });
    }
}

// EQUAl HEIGHT BLOCKS
function setup_equal_height() {
    if ($('.equal-height').length > 0) {
        $('.equal-height .news-content').matchHeight();
    }
}

// RUN WHEN RESIZING HAS STOPPED
var resizeTimer;
$(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        // ADD CLOSEABLE EVENTS AFTER RESIZING
        setup_closeable('false');
    }, 250);

});